<template>
    <v-card height="100%">
        <v-card-text class="pb-0">
            <v-row no-gutters>
                <v-col>
                    <v-row no-gutters>
                        <v-col class="text-no-wrap">
                            <div class="subtitle-2">{{ computedInvestigator.title }}</div>
                            <div class="caption">{{ computedInvestigator.gamePack.title }}</div>
                        </v-col>

                        <v-col class="text-right">
                            <v-menu offset-y v-if="giveToEnabled">
                                <template #activator="{ on: onMenu }">
                                    <v-tooltip bottom>
                                        <template #activator="{ on: onTooltip }">
                                            <v-btn color="primary"
                                                   icon
                                                   v-on="{ ...onMenu, ...onTooltip }">
                                                <v-icon>mdi-account-arrow-right</v-icon>
                                            </v-btn>
                                        </template>

                                        <span>Move to</span>
                                    </v-tooltip>
                                </template>

                                <v-list>
                                    <v-list-item
                                            v-for="(to, toIndex) in game.activeInvestigatorSessions"
                                            :key="toIndex"
                                            @click="$emit('giveTo', investigatorSessionIndex, toIndex)">
                                        <v-list-item-title>{{ to.investigator.initial_and_surname }}
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>

                            <v-tooltip bottom v-if="investigatorSession">
                                <template #activator="{on}">
                                    <v-btn v-if="investigatorSession"
                                           icon
                                           v-on="on"
                                           @click="$emit('deleteInvestigator', investigatorSession)"
                                           color="error">
                                        <v-icon>mdi-close-circle</v-icon>
                                    </v-btn>
                                </template>

                                <span v-if="investigatorSession.state === 1">Remove from the game</span>
                                <span v-else>Return to the game</span>
                            </v-tooltip>

                            <v-btn v-if="investigator"
                                   text
                                   small
                                   @click="$emit('chooseInvestigator', investigator)"
                                   color="primary">
                                Select
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-row no-gutters v-if="investigatorSession">
                        <v-col>
                            <span class="caption">Cards: {{ investigatorSession.cardBacks.length }}</span>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <v-row v-if="investigator">
                <v-col>
                    <v-row no-gutters>
                        <v-col>
                            <div>Starting location</div>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col>
                            <div>
                                {{ investigator.starting_location }}
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <v-row>
                <v-col>
                    <v-row no-gutters>
                        <v-col class="mb-2">
                            <span><span class="eh red--text" style="font-size: 1.7em;">K</span> {{ computedInvestigator.health }}</span>
                            <span class="ml-3"><span class="eh blue--text text--darken-3" style="font-size: 1.7em;">L</span> {{ computedInvestigator.sanity }}</span>
                        </v-col>
                    </v-row>

                    <v-row no-gutters>
                        <v-col>
                            <span><span class="eh">A</span> {{ computedInvestigator.lore }}</span>
                            <span class="ml-2"><span class="eh">S</span> {{ computedInvestigator.influence }}</span>
                            <span class="ml-2"><span class="eh">D</span> {{ computedInvestigator.observation }}</span>
                            <span class="ml-2"><span class="eh">F</span> {{ computedInvestigator.strength }}</span>
                            <span class="ml-2"><span class="eh">G</span> {{ computedInvestigator.will }}</span>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <v-row v-if="investigator">
                <v-col>
                    <v-row no-gutters>
                        <v-col>
                            <div>Starting Items</div>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col>
                            <div v-for="(cardFront, cardFrontIndex) in investigator.cardFronts"
                                 :key="'cardFront-' + cardFrontIndex">
                                1 {{ cardFront.title }} <span
                                    class="text-lowercase">{{ cardFront.cardType.title }}</span>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row no-gutters v-if="investigator.starting_items">
                        <v-col>
                            <div v-for="(startingItem, startingItemIndex) in investigator.starting_items"
                                 :key="'startingItem-' + startingItemIndex">{{ startingItem }}
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <v-row v-if="investigator">
                <v-col>
                    <v-row no-gutters>
                        <v-col>
                            <div>Abilities</div>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col>
                            <div v-for="(ability, abilityIndex) in investigator.abilities"
                                 :key="'ability-' + abilityIndex">
                                {{ ability }}
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
  export default {
    props: [
      "investigator",
      "investigatorSession",
      "investigatorSessionIndex",
      "game"
    ],

    computed: {
      computedInvestigator: function () {
        if (this.investigatorSession) {
          return this.investigatorSession.investigator;
        }

        return this.investigator;
      },

      giveToEnabled: function () {
        if (this.investigatorSession) {
          return this.investigatorSession.state === 1;
        }

        return false;
      }
    }
  };
</script>

<style>
    @font-face {
        font-family: eldritch;
        src: url(../../src/assets/EldritchHorrorIcons_v2_1.ttf) format("truetype");
    }

    .eh {
        font-family: eldritch,serif;
        font-size: 1.2em;
    }
</style>